import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const QuoteIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.primary.main,
  size = IconSize.small,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="38"
        height="34"
        viewBox="0 0 38 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.2661 6.89936C16.2164 6.50085 16.6149 5.36662 16.1857 4.44697L14.6837 1.28953C14.2545 0.400846 13.2122 0.0020266 12.2926 0.400846C9.68692 1.50442 7.44912 2.94519 5.67114 4.69252C3.49465 6.74608 2.02322 9.1065 1.22619 11.7122C0.429167 14.3488 0 17.9351 0 22.5027V31.9137C0 32.9253 0.82768 33.753 1.83929 33.753H13.8866C14.8982 33.753 15.7259 32.9253 15.7259 31.9137V19.8663C15.7259 18.8544 14.8982 18.0271 13.8866 18.0271H8.12352C8.18483 14.9306 8.92055 12.4479 10.2694 10.5776C11.3729 9.07616 13.0283 7.84996 15.2661 6.89936Z"
          fill={color}
        />
        <path
          d="M36.9073 6.89982C37.8576 6.5013 38.2558 5.36708 37.827 4.44743L36.3249 1.32095C35.8957 0.431959 34.8534 0.0334461 33.9338 0.431959C31.3588 1.53553 29.1513 2.97631 27.343 4.69298C25.1662 6.7775 23.6644 9.13793 22.8671 11.7436C22.0701 14.3183 21.6719 17.9052 21.6719 22.5034V31.9145C21.6719 32.9261 22.4996 33.7537 23.5112 33.7537H35.5585C36.5701 33.7537 37.3978 32.9261 37.3978 31.9145V19.8671C37.3978 18.8552 36.5701 18.0278 35.5585 18.0278H29.7647C29.8261 14.9314 30.5621 12.4486 31.9106 10.5784C33.0142 9.07662 34.6695 7.85042 36.9073 6.89982Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
